<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{ version }}</span>
    <loading
      :active.sync="loading"
      :can-cancel="false"
      :is-full-page="true"
    ></loading>

    <div class="mt-4">
      <div class="divSubtitulo d-flex justify-content-between m-1 mb-3">
        <p class="textoSubtitulo">Histórico de tratamientos del paciente</p>
        <p style="text-align: end" class="textoSubtitulo">CÓDIGO</p>
      </div>

      <div class="d-flex justify-content-start mt-5">
        <div
          v-for="(tab, index) in tabs"
          v-bind:key="index"
          class="mr-3 text-left"
          :class="activeTabIndex == index ? 'selected-tab' : 'default-tab'"
          @click="activeTabIndex = index"
        >
          <p class="m-0">{{ tab.title }}</p>
          <p class="m-0 p-0" style="font-weight: bold">{{ tab.conteo }}</p>
        </div>
      </div>

      <div class="mt-5">
        <b-table
          responsive
          id="tratamientos"
          :items="itemsFiltrados"
          :fields="fields"
          :per-page="registrosPorPagina"
          :current-page="paginaActual"
          :ref="1"
        >
          <template v-slot:cell(nombreTratamiento)="row" >
            <div v-if="row.item.idKitTratamientos === null || row.item.idKitTratamientos === ''">
              {{row.item.nombreTratamiento}}
            </div>
            <div v-else v-b-tooltip.hover :title="'kit: ' + row.item.nombreKit">
              <p><em class="txt_kit mr-1" style="width: 3.2em;"></em>{{row.item.nombreTratamiento}}</p>
            </div>
          </template>
          <template v-slot:cell(fechaAlta)="row">
            <div>
              {{ row.item.fechaAlta | formatoFecha }}
            </div>
          </template>
          <template v-slot:cell(doctor)="row">
            <div>
              {{
                row.item.doctor === null || row.item.doctor === ""
                  ? "Sin dato"
                  : row.item.doctor
              }}
            </div>
          </template>
          <template v-slot:cell(precioTotal)="row">
            <div>{{ row.item.precioOriginalSesion | moneda }}</div>
          </template>

          <template v-slot:cell(numeroSesion)="row">
            <div>
              {{
                row.item.numeroSesion === null || row.item.numeroSesion === ""
                  ? "Sin dato"
                  : row.item.numeroSesion + "/" + row.item.numeroMaxSesiones
              }}
            </div>
          </template>
          <template v-slot:cell(descuento)="row" >
            <div v-if="row.item.descuento == null || row.item.descuento == 0" >
              <p>$0</p>
            </div>
            <div v-else-if="row.item.descuento != null && row.item.descuento != 0" class="d-flex justify-content-center" v-b-tooltip.hover :title="row.item.nombrePlan">
              <p class="m-0 p-0">{{ row.item.descuento + "%" }}</p>
              <em class="info_outline ml-1"></em>
            </div>
          </template>
          <template v-slot:cell(montoVale)="row">
            <div v-if="row.item.idPacienteVale != null && row.item.montoVale > 0" class="d-flex justify-content-center" v-b-tooltip.hover :title="row.item.nombreVale">
              <p class="m-0 p-0">{{ row.item.montoVale | moneda }}</p>
              <em class="info_outline ml-1"></em>
            </div>
            <div v-else>
              <p>$0</p>
            </div>
          </template>
          <template v-slot:cell(montoPromocion)="row">
            <div v-if="row.item.idPromocion != null && row.item.montoPromocion > 0" class="d-flex justify-content-center" v-b-tooltip.hover :title="row.item.nombrePromocion">
              <p class="m-0 p-0">{{ row.item.montoPromocion | moneda }}</p>
              <em class="info_outline ml-1"></em>
            </div>
            <div v-else>
              <p>$0</p>
            </div>
          </template>
          <template v-slot:cell(montoCupon)="row">
            <div v-if="row.item.idCupon == null" >
              <p>$0</p>
            </div>
            <div v-else-if="row.item.idCupon != null" class="d-flex justify-content-center" v-b-tooltip.hover :title="row.item.nombreCupon">
              <p class="m-0 p-0">{{ row.item.montoCupon | moneda }}</p>
              <em class="info_outline ml-1"></em>
            </div>
          </template>
          <template v-slot:cell(precioSesion)="row">
            <div>
              {{ row.item.precioSesion | moneda }}
            </div>
          </template>
          <template v-slot:cell(saldoFavor)="row">
            <div>
              {{ row.item.saldoFavor | moneda }}
            </div>
          </template>
          <template v-slot:cell(montoReembolso)="row">
            <div>
              {{ row.item.montoReembolso | moneda }}
            </div>
          </template>
          <template v-slot:cell(nombrePlan)="row">
            <div>
              {{
                row.item.nombrePlan === null || row.item.nombrePlan === ""
                  ? "Sin dato"
                  : row.item.nombrePlan
              }}
            </div>
          </template>

          <template v-slot:cell(presupuestoHistorico)="row">
            <span v-if="row.item.presupuestoHistorico == true">
              <em class="outline_check" style="width: 1.5em"></em>
            </span>
            <span v-else>
                <em class="close_x" style="width: 1.5em"></em>
            </span>
          </template>
          <template v-slot:cell(idEstatusTratamiento)="row">
            <p v-if="row.item.idEstatusTratamiento == 1">Programado</p>
            <p v-else-if="row.item.idEstatusTratamiento == 15">Ejecutado</p>
            <p v-else-if="row.item.idEstatusTratamiento == 28">Eliminado</p>
          </template>
        </b-table>
        <b-pagination
          v-if="itemsFiltrados !== undefined && itemsFiltrados.length > 15"
          align="center"
          v-model="paginaActual"
          :total-rows="tratamientossesion.length"
          :per-page="registrosPorPagina"
          aria-controls="tratamientos"
        ></b-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "tratamientosprogramados",
  components: {},
  props: {
    idPaciente: null,
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    banderaBtn: false,
    selected: [],
    selectMode: "multi",
    tratamientossesion: [],
    loaderListaTratamientos: false,
    currentPage: 1,
    registrosPorPagina: 15,
    paginaActual: 1,
    fields: [
      { key: "fechaAlta", label: " Fecha alta tratamiento ", sortable: true  },
      { key: "origen", label: "Origen del tx" },
      { key: "nombreTratamiento", label: "Tratamiento", sortable: true },
      { key: "doctor", label: "Doctor", sortable: true  },
      { key: "numeroDiente", label: "OD", sortable: true  },
      { key: "precioTotal", label: "Precio" },
      { key: "numeroSesion", label: "Num. Sesión" },
      { key: "descuento", label: "Descuento plan" },
      { key: "montoVale", label: "Descuento vale" },
      { key: "montoPromocion", label: "Descuento promoción" },
      { key: "montoCupon", label: "Descuento cupón" },
      { key: "precioSesion", label: "Precio Total" },
      { key: "saldoFavor", label: "Saldo abonado" },
      { key: "montoReembolso", label: "Saldo reembolsado" },
      { key: "nombreEspecialidad", label: "Especialidad" },
      { key: "presupuestoHistorico", label: "Presupuesto Histórico" },
      { key: "idEstatusTratamiento", label: "Estado" },
    ],
    tabs: [
      {
        title: "Todos",
        conteo: 6,
      },
      {
        title: "Ejecutados",
        conteo: 12,
      },
      {
        title: "Programados",
        conteo: 1,
      },
      {
        title: "Eliminados",
        conteo: 5,
      },
    ],
    activeTabIndex: 0,
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
  computed: {
    itemsFiltrados() {
      switch (this.activeTabIndex) {
        case 0:
          return this.tratamientossesion;
        case 1:
          return this.tratamientossesion.filter(
            (tx) => tx.idEstatusTratamiento == 15
          );
        case 2:
          return this.tratamientossesion.filter(
            (tx) => tx.idEstatusTratamiento == 1
          );
        case 3:
          return this.tratamientossesion.filter(
            (tx) => tx.idEstatusTratamiento == 28
          );
        default:
          return [];
      }
    },
  },
  watch: {
    activeTabIndex() {
      this.paginaActual = 1;
    },
  },
  mounted() {
    this.obtenerListaTratamientos();
  },
  methods: {
    obtenerListaTratamientos() {
      this.tratamientossesion = [];
      this.loaderListaTratamientos = true;
      const parametros = { idPaciente: this.idPaciente };
      this.$http
        .post(this.$api + "tratamiento_sesion/txProgramados", parametros)
        .then((response) => {
          if (response.data.data) {
            let resultado = response.data.data;
            resultado.forEach((it) => {
              this.paginaActual = 1;
              this.tratamientossesion.push(it);
            });

            this.tabs[0].conteo = this.tratamientossesion.length;
            this.tabs[1].conteo = this.tratamientossesion.filter(
              (tx) => tx.idEstatusTratamiento == 15
            ).length;
            this.tabs[2].conteo = this.tratamientossesion.filter(
              (tx) => tx.idEstatusTratamiento == 1
            ).length;
            this.tabs[3].conteo = this.tratamientossesion.filter(
              (tx) => tx.idEstatusTratamiento == 28
            ).length;
          }
          this.loaderListaTratamientos = false;
        })
        .catch(function (error) {
          console.error(error);
          this.loaderListaTratamientos = false;
        });
    },
  },
};
</script>

<style scoped>
.default-tab {
  min-width: 15vw;
  border: 1px solid #c2c2c2;
  border-radius: 10px;
  color: #c2c2c2;
  cursor: pointer;
  padding: 1%;
}

.selected-tab {
  min-width: 15vw;
  border: 1px solid #5691b4;
  border-radius: 10px;
  color: #5691b4;
  cursor: pointer;
  padding: 1%;
}
</style>
